import {Navbar,Footer} from '../components';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import * as Icon from 'react-bootstrap-icons';
import { closestToWithOptions } from 'date-fns/fp';
import { Modal, Button, Form, Tabs, Tab } from "react-bootstrap";

function OverheadEntry(){
    if(localStorage.getItem('branchID')===null){
        window.location.replace('/');
    }

    const [expCompList,setExpCompList]=useState([]);
    const [inputData,setInputData]=useState([]);    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    
    useEffect(() => {
        const getOverheadList = async () => {
            const response=await axios.get(configData.SERVER_URL+`/expCompDetails`);
            console.log(response);
            setExpCompList(response.data);
        };
        getOverheadList();
    
    }, []);



    return(
    <>
        <div className='container'>
        <Navbar />
            {/* <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Transfer/Promotion History</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Year</Form.Label>
                            <Form.Control type="number" id="fYear" name="fYear" value={inputData.fYear} onChange={(e)=>{handleInput(e)}} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Estimated Exp.</Form.Label>
                            <Form.Control type="number" id="estimatedExp" name="estimatedExp" value={inputData.estimatedExp} onChange={(e)=>{handleInput(e)}} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Year</Form.Label>
                            <Form.Control type="number" id="fYear" name="fYear" value={inputData.fYear} onChange={(e)=>{handleInput(e)}} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Year</Form.Label>
                            <Form.Control type="number" id="fYear" name="fYear" value={inputData.fYear} onChange={(e)=>{handleInput(e)}} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
            </Modal> */}
            <div className='card'>
                <div className='card-body'>
                    <div className='card-header bg-info'>Overhead details</div>
                    <div className="table-responsive">
                        <table class="table table-success table-hover table-bordered">
                            <thead>
                            <tr>
                                <th>SL No.</th>
                                <th>Year</th>
                                <th>Head</th>
                                <th>Sub-Head</th>
                                <th>Descriptions</th>
                                <th>Estimated Exp.</th>
                                <th>Revised Exp.</th>
                                <th>Actual Exp.</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                            expCompList && expCompList.length>0 && expCompList.map((data,index)=>
                            <tr align="right" key={data.id} >
                                <td align="left">{index+1}</td>   
                                <td align="left">{data.fYear}</td>
                                <td align="left">{data.overheadName}</td>
                                <td align="left">{data.subOverheadName}</td>
                                <td align="left">{data.description}</td>
                                <td align="right">{data.estimatedExp}</td>
                                <td align="right">{data.revisedExp}</td>
                                <td align="right">{data.actualExp}</td>
                                <td><button className='btn btn-info'><Icon.ArrowRight onClick={() => {}}/></button></td>
                            </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        <Footer />
        </div>
    </>
    )
}

export default OverheadEntry;